import { useSelector, useDispatch } from 'react-redux';
import { RootAppState } from '../store';
import {
  addProdutoPedidoAction,
  cleanPedidoAction,
  setEnderecoAction,
  setObservacaoAction,
  setPedidoAction,
  delProdutoPedidoAction,
  editProdutoPedidoAction,
  setCupomAction,
  addProdutoCompostoPedidoAction,
  delProdutoCompostoPedidoAction
} from './pedidoActions';
import Pedido from '../../shared/entity/Pedido';
import Produto from '../../shared/entity/Produto';
import ProdutoNoPedido from '../../shared/entity/ProdutoNoPedido';
import Endereco from '../../shared/entity/Endereco';
import Cupom from '../../shared/entity/Cupom';
import ProdutoCompostoNoPedido from '../../shared/entity/ProdutoCompostoNoPedido';

export const usePedido = (): [Pedido, (pedido: Pedido) => void, () => void] => {
  const dispatch = useDispatch();
  const pedido = useSelector((state: RootAppState) => state.pedido);

  const setPedido = (pedido) => {
    const action = setPedidoAction(pedido);
    dispatch(action);
  };

  const limparPedido = () => {
    const action = cleanPedidoAction();
    dispatch(action);
  };
  return [pedido, setPedido, limparPedido];
};

export const useDadosPedido = (): [
  (end: Endereco | null) => void,
  (obs: string) => void,
  (cupom: Cupom) => void
] => {
  const dispatch = useDispatch();

  const setEnderecoPedido = (end: Endereco | null) => {
    const action = setEnderecoAction(end);
    dispatch(action);
  };

  const setObservacaoPedido = (obs: string) => {
    const action = setObservacaoAction(obs);
    dispatch(action);
  };

  const setCupomPedido = (cupom: Cupom | null) => {
    const action = setCupomAction(cupom);
    dispatch(action);
  };

  return [setEnderecoPedido, setObservacaoPedido, setCupomPedido];
};

export const useProdutosNoPedido = (): [
  (prod: ProdutoNoPedido) => void,
  (i: number) => void,
  (index: number, novoProduto: ProdutoNoPedido) => void
] => {
  const dispatch = useDispatch();
  const pedido = useSelector((state: RootAppState) => state.pedido);

  const adicionarProdutoNoPedido = (produto: ProdutoNoPedido) => {
    const action = addProdutoPedidoAction(produto);
    dispatch(action);
  };

  const removerProdutoNoPedido = (index: number) => {
    const action = delProdutoPedidoAction(index);
    dispatch(action);
  };

  const editarProdutoNoPedido = (index: number, novoProduto: ProdutoNoPedido) => {
    const action = editProdutoPedidoAction({ index, produto: novoProduto });
    dispatch(action);
  };

  return [adicionarProdutoNoPedido, removerProdutoNoPedido, editarProdutoNoPedido];
};

export const useProdutosCompostosNoPedido = (): [
  (prod: ProdutoCompostoNoPedido) => void,
  (i: number) => void
] => {
  const dispatch = useDispatch();
  const pedido = useSelector((state: RootAppState) => state.pedido);

  const adicionarProdutoCompostoNoPedido = (produto: ProdutoCompostoNoPedido) => {
    if (produto.produtos.length !== 2) {
      return;
    }

    // TAMANHO //////////////////////////////////////////////
    let preco0 = produto.produtos[0].tamanhoSelecionado.preco;
    if (produto.produtos[0].tamanhoSelecionado.precoPromocional > 0) {
      preco0 = produto.produtos[0].tamanhoSelecionado.precoPromocional;
    }

    let preco1 = produto.produtos[1].tamanhoSelecionado.preco;
    if (produto.produtos[1].tamanhoSelecionado.precoPromocional > 0) {
      preco1 = produto.produtos[1].tamanhoSelecionado.precoPromocional;
    }

    let tamanhoSelecionado;
    if (preco0 > preco1) {
      tamanhoSelecionado = { ...produto.produtos[0].tamanhoSelecionado };
    } else {
      tamanhoSelecionado = { ...produto.produtos[1].tamanhoSelecionado };
    }
    produto.produtos[0].tamanhoSelecionado = tamanhoSelecionado;
    produto.produtos[1].tamanhoSelecionado = tamanhoSelecionado;
    /////////////////////////////////////////////////////////

    // QUANTIDADE ///////////////////////////////////////////
    const quantidade =
      produto.produtos[0].quantidadeNoPedido > produto.produtos[1].quantidadeNoPedido
        ? produto.produtos[0].quantidadeNoPedido
        : produto.produtos[1].quantidadeNoPedido;

    produto.produtos[0].quantidadeNoPedido = quantidade;
    produto.produtos[1].quantidadeNoPedido = quantidade;
    //////////////////////////////////////////////////////////
    const action = addProdutoCompostoPedidoAction(produto);
    dispatch(action);
  };

  const removerProdutoCompostoNoPedido = (index: number) => {
    const action = delProdutoCompostoPedidoAction(index);
    dispatch(action);
  };

  // const editarProdutoCompostoNoPedido = (index: number, novoProduto: ProdutoCompostoNoPedido) => {
  //   const action = editProdutoPedidoAction({ index, produto: novoProduto });
  //   dispatch(action);
  // };

  return [adicionarProdutoCompostoNoPedido, removerProdutoCompostoNoPedido];
};
